module.exports = __webpack_public_path__ + "img/combojetvac_stopped.b66ca824.svg";